import { createRouter, createWebHistory } from 'vue-router'
// import AnggotaLogin from '@/views/Anggota/Login.vue'
// const AggotaFormulir = () => import('../views/Anggota/Formulir.vue')
// const AggotaSukses = () => import('../views/Anggota/Success.vue')

// const PICPendataanLogin = () => import('../views/PICPendataan/Login.vue')
// const PICPendataanListGudep = () => import('../views/PICPendataan/ListGudep.vue')
// const PICPendataanListAnggota = () => import('../views/PICPendataan/ListAnggota.vue')

// const PIGudepListAnggota = () => import() '../views/PICGudep/ListAnggota.vue'

// const Page404 = () => import('../views/404.vue')
// import Layout from '@/layout/index.vue'


const routes = [
  // {
  //   path: '/anggota-login',
  //   name: 'Anggota Login',
  //   component: AnggotaLogin,
  // },
  {
    path: '/',
    name: 'Layout',
    component: () => import('../layout/index.vue'),
    children: [
      {
        path: '',
        name: 'pic-login',
        component: () => import('../views/PICPendataan/Login.vue'),
      },
      {
        path: '/pendataan/:projectid/kwarran/:kwarranid/:gudepid',
        name: 'anggota-formulir',
        component: () => import('../views/Anggota/Formulir.vue'),
      },
      {
        path: '/anggota-sukses',
        name: 'anggota-sukses',
        component: () => import('../views/Anggota/Success.vue'),
      },
      {
        path: '/tasks/potret',
        name: 'task-potret',
        component: () => import('../views/PICPendataan/ListGudep.vue'),
      },
      {
        path: '/pic-pendataan-list-anggota/:projectid/:gudepid/:kwarranid/:taskid',
        name: 'ListPotret',
        component: () => import('../views/PICPendataan/ListAnggota.vue'),
      },
      // {
      //   path: '/pic-gudep-login',
      //   name: 'PIC Gudep Login',
      //   component: PICPendataanLogin,
      // },
      // {
      //   path: '/pic-gudep-list-anggota/:id',
      //   name: 'PIC Gudep List Anggota',
      //   component: PIGudepListAnggota,
      // },
      // {
      //   path: '/pic-gudep-formulir',
      //   name: 'PIC Gudep Formulir',
      //   component: AggotaFormulir,
      // },
    ]
  },

  {
    path: '/:catchAll(.*)',
    meta: { auth: false, name: 'Page tidak ditemukan' },
    component: () => import('../views/404.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
